// import * as Sentry from '@sentry/browser';
// import { getTowerVersion } from './modules/utils';

// export default function (dsn) {
//   if (!dsn) return;

//   if (process.env.NODE_ENV === 'production') {
//     Sentry.init({
//       dsn,
//       release: getTowerVersion(),
//       whitelistUrls: ['tower.im'],
//       beforeSend(event) {
//         return (window.gon && window.gon.isBrowserCompatible) ? event : null;
//       },
//     });
//   }
// }

export default function () {}
